// extracted by mini-css-extract-plugin
export default {"containerGlobal":"ViewExtractMoth_containerGlobal__OA3la","divList":"ViewExtractMoth_divList__aJ3Lt"};